import React from "react";
import "./index.scss";
import { Col, Row } from "antd";

const TestimonialsPage = () => {
  return (
    <div className="testimonialspage-main">
      {/* Banner */}
      <div id="banner-area">
        <div className="about-overlay"></div>
        <div className="banner-title-content">
          <h2>Testimonials</h2>
        </div>
      </div>

      <Row>
        <Col
          xs={{ span: 22, offset: 1 }}
          sm={{ span: 22, offset: 1 }}
          md={{ span: 22, offset: 1 }}
          lg={{ span: 18, offset: 4 }}
          xl={{ span: 18, offset: 4 }}
        >
          <h2 className="header">
            <span>
              <img src="/images/icons/discussion.png" alt="" />
            </span>
            What Our Clients Say
          </h2>
        </Col>
      </Row>

      {/* Row 1 */}
      <div className="row">
        <div className="card-main">
          <div className="card-content">
            CDC’s overall service in the areas of recruiting, screening and
            assessment of candidates, personalized customer service and the
            relationships they maintain with their employees are the kind of
            traits that our company looks for in a staffing vendor.
          </div>

          <div className="card-footer">
            <div className="card-sign">
              Vice President
              <br />
              <span className="card-subsign"> HR of a Life Sciences Firm</span>
            </div>
          </div>
        </div>

        <div className="card-main">
          <div className="card-content">
            As a client, we have consistently found CDC as an important partner
            for hiring talented people. CDC has been able to provide us with the
            best in class services. I can recommend CDC as an excellent business
            partner with a passion to provide quality candidates that fit our
            needs
          </div>

          <div className="card-footer">
            <div className="card-sign">
              Director
              <br />
              <span className="card-subsign"> Vendor Management of a Pharmaceutical Company in NJ.</span>
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />

      {/* Row 2 */}
      <div className="row">
        <div className="card-main">
          <div className="card-content">
            CDC has been our business partner for several years. They have been
            able to meet our needs for temporary and permanent staffing needs.
            In addition, their turnaround time is quick, and customer service is
            among the best.
          </div>

          <div className="card-footer">
            <div className="card-sign">
              Client Partner of an IT Consulting Company.
            </div>
          </div>
        </div>

        <div className="card-main">
          <div className="card-content">
            Our company partnered with CDC for our key staffing and recruitment
            needs. They have consistently shown a great ability in finding the
            top talent we need to help grow our firm. We have found they work as
            a true partner with our team to insure we have the right person,
            with the right skills, and right fit for our team
          </div>

          <div className="card-footer">
            <div className="card-sign">
              Recruitment Director of a Restaurant Chain
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;
